export default __webpack_public_path__ + "static/media/icon-search-filled.72da593e.svg";